import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import db from '../../FireBase/firebaseConfig';

const FirebaseTest = () => {
  const [documentId, setReqId] = useState("d7604bf4-bf9e-4803-7b8f-08dd4f59d624");
  const [payment, setPayment] = useState(null); // State to hold the filtered payment data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // State to hold any errors

  useEffect(() => {
    const docRef = doc(db, "payment_results", documentId); // "payment_result" is your collection name

    // Using onSnapshot for real-time updates
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      setLoading(true); // Start loading
      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data()); // Log the document data
        setPayment(docSnap.data()); // Set payment data from Firestore
      } else {
        console.log("No document found with the given ID");
        setPayment(null); // Set payment to null if no document is found
      }
      setLoading(false); // End loading
    }, (error) => {
      console.error("Error fetching payment: ", error);
      setError(error.message); // Set error message
      setLoading(false); // End loading
    });

    // Cleanup the listener on component unmount
    return () => {
      unsubscribe();
    };
  }, [documentId]);

  if (loading) {
    return <div>Loading...</div>; // Show loading state
  }

  if (error) {
    return <div>Error: {error}</div>; // Show any error message
  }

  if (!payment) {
    return <div>No payment found for the document ID: {documentId}</div>; // Show if no payment data is found
  }

  return (
    <div>
      <h2>Payment Details for Document ID: {documentId}</h2>
      <table border="1">
        <thead>
          <tr>
            <th>Request ID</th>
            <th>Quote</th>
            <th>Type</th>
            <th>Payment Status</th>
            <th>Approval Result</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{payment.RequestId ?? "N/A"}</td>
            <td>{payment.Quote ?? "N/A"}</td>
            <td>{payment.Type ?? "N/A"}</td>
            <td>{payment.PaymentStatus ?? "N/A"}</td>
            <td>{payment.ApprovalResult ?? "N/A"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FirebaseTest;
